
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Busonrentforeventinpune() {



    const cardData =
    {
        keyword: '  Bus on Rent For Event in Pune',
        heading: 'Samarth Travels: Bus on Rent For Event in Pune',
        headingDescription: 'Samarth Travels offers bus on rent for events in Pune, ideal for weddings, exhibitions, corporate gatherings, and social functions. Choose from a fleet of AC and non-AC buses ranging from 17 to 50 seaters, all well-maintained for guest comfort. With punctual service, courteous drivers, and transparent pricing, Samarth Travels ensures smooth and reliable group transport for every event.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Event Bus Rental Services in Pune",
        "description": "Samarth Travels offers specialized event bus rental services in Pune for various occasions. Whether it’s a wedding, corporate function, or cultural event, our buses are designed to cater to large groups, ensuring everyone travels comfortably to the event."
    },
    {
        "name": "Rent Bus for Wedding Events in Pune",
        "description": "Make your wedding day special with Samarth Travels' bus rental services for wedding events in Pune. We offer buses that can accommodate your guests in comfort, ensuring smooth transport to and from wedding venues, while enhancing the overall experience."
    },
    {
        "name": "Bus Hire for Corporate Events in Pune",
        "description": "Rent a bus for your next corporate event with Samarth Travels. Our fleet is perfect for transporting employees and clients to conferences, seminars, or team-building events in Pune. With spacious and comfortable seating, your corporate guests will enjoy a hassle-free ride."
    },
    {
        "name": "Bus for Cultural Events on Rent in Pune",
        "description": "Samarth Travels offers buses for cultural events in Pune, providing group transport solutions for large gatherings such as festivals, theater performances, and exhibitions. Our buses are equipped with modern amenities to ensure a comfortable journey for all attendees."
    },
    {
        "name": "Rent a Bus for Conferences in Pune",
        "description": "If you're hosting a conference in Pune, Samarth Travels provides reliable bus rental services to transport your delegates. Our buses offer comfort, air-conditioning, and timely services, ensuring your attendees arrive refreshed and on time."
    },
    {
        "name": "Bus Hire for Birthday Parties in Pune",
        "description": "Celebrate your birthday in style by renting a bus from Samarth Travels. Perfect for transporting guests to and from the party venue, our buses are equipped with air-conditioning and ample space to ensure that your birthday celebration starts and ends on a high note."
    },
    {
        "name": "Affordable Bus Hire for Event Travel in Pune",
        "description": "Samarth Travels offers budget-friendly bus hire options for event travel in Pune. Whether it’s a wedding, corporate outing, or any other event, we provide affordable transportation without compromising on comfort or service."
    },
    {
        "name": "Bus Rental for Group Events in Pune",
        "description": "For group events in Pune, Samarth Travels offers convenient bus rental services. Whether it’s a sports event, conference, or family gathering, our buses are perfect for large groups, ensuring everyone travels together in comfort and style."
    },
    {
        "name": "Luxury Bus Hire for Events in Pune",
        "description": "For high-end events in Pune, hire a luxury bus from Samarth Travels. Our luxury buses come with premium amenities such as plush seating, air-conditioning, and entertainment systems, providing an exclusive and comfortable transport experience for your guests."
    },
    {
        "name": "32-Seater Bus Rental for Events in Pune",
        "description": "Samarth Travels offers 32-seater bus rental services for events in Pune. Perfect for medium-sized groups, these buses are equipped with air-conditioning, comfortable seating, and plenty of space, ensuring that your guests enjoy a relaxed and smooth ride."
    }
],
"tableData": [
    ["Event Bus Rental Services in Pune", "Rent Bus for Wedding Events in Pune"],
    ["Bus Hire for Corporate Events in Pune", "Bus for Cultural Events on Rent in Pune"],
    ["Rent a Bus for Conferences in Pune", "Bus Hire for Birthday Parties in Pune"],
    ["Affordable Bus Hire for Event Travel in Pune", "Bus Rental for Group Events in Pune"],
    ["Luxury Bus Hire for Events in Pune", "32-Seater Bus Rental for Events in Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Bus Rental Service for Events in Pune",
        "WhyChoosedescription": "Samarth Travels offers reliable and professional bus rental services for events in Pune, whether it's a corporate seminar, wedding celebration, school function, or public gathering. We ensure smooth, timely, and organized group transportation so your guests arrive comfortably and on schedule."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Buses for All Event Sizes",
        "WhyChoosedescription": "Our fleet includes a range of buses suitable for events of all scales—from 17-seater minibuses to 50+ seater large coaches. Each bus is equipped with comfortable seating, air-conditioning, and ample legroom to ensure that your guests enjoy a relaxed and pleasant ride, regardless of the distance or duration."
    },
    {
        "WhyChooseheading": "Professional Drivers to Ensure Smooth Event Logistics",
        "WhyChoosedescription": "We understand the importance of punctuality and professionalism when it comes to event transportation. Our skilled drivers are courteous, well-dressed, and punctual. They are trained to handle large groups and are familiar with event venues across Pune, ensuring smooth pick-up and drop-off coordination."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Event Rentals",
        "WhyChoosedescription": "Samarth Travels offers competitive and transparent pricing with no hidden charges. Whether you need buses for a few hours or the entire day, we provide flexible rental packages that suit your event budget. You get high-quality service at a price that adds value to your overall event planning."
    },
    {
        "WhyChooseheading": "24/7 Availability to Suit Your Event Schedule",
        "WhyChoosedescription": "Events can happen at any hour, and so can our services. Samarth Travels provides 24/7 availability for bus rentals, allowing you to schedule transportation early in the morning or late at night. We’re committed to supporting your event's timeline without delay or disruption."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking and Real-Time Updates",
        "WhyChoosedescription": "Booking your event transportation is simple and quick through our website or customer care. Once confirmed, you’ll receive real-time tracking information, driver contact details, and updates on bus arrivals. This helps event coordinators and organizers stay informed and manage logistics with confidence."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "We maintain our buses to the highest standards of cleanliness and safety. Before every trip, buses are thoroughly cleaned and sanitized to provide a hygienic environment for your guests. Regular maintenance ensures that all buses run smoothly and are equipped with essentials for guest comfort."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenience",
        "WhyChoosedescription": "We offer multiple easy payment options including UPI, credit/debit cards, digital wallets, and cash, making it convenient for you to complete your booking. Whether you're an individual, company, or event planner, we ensure a smooth and secure transaction experience."
    }
]


















    }

const faqData = [
    {
        id: 1,
        question: 'How do I rent a bus for an event in Pune with Samarth Travels?',
        answer: 'Renting a bus for your event in Pune with Samarth Travels is easy. You can book through our website or by calling our customer support team. Provide your event details such as the number of attendees, event location, and preferred bus type, and we’ll arrange the perfect vehicle for you.',
    },
    {
        id: 2,
        question: 'What types of buses are available for event rentals in Pune?',
        answer: 'We offer a variety of buses for events in Pune, including 22-seater, 32-seater, 40-seater, and 50-seater buses. You can choose from AC and Non-AC buses depending on your event requirements and comfort preferences.',
    },
    {
        id: 3,
        question: 'Are the buses equipped for corporate or social events?',
        answer: 'Yes, our buses are designed to accommodate both corporate events and social gatherings. They are equipped with comfortable seating, ample luggage space, and clean interiors. AC buses are ideal for providing extra comfort during longer events or journeys.',
    },
    {
        id: 4,
        question: 'Can I rent a bus for a one-day event in Pune?',
        answer: 'Yes, we offer one-day bus rental options for events. Whether it’s a conference, wedding, or any other event, our buses are available for short-term rentals, ensuring reliable and comfortable transportation for your guests or attendees.',
    },
    {
        id: 5,
        question: 'What is included in the bus rental for an event?',
        answer: 'Our event bus rental includes the vehicle, driver, and fuel. Any additional charges like tolls, parking fees, or permits will be communicated upfront for complete transparency. We aim to provide hassle-free transportation for your event.',
    },
    {
        id: 6,
        question: 'Can I customize the pickup and drop-off locations for my event?',
        answer: 'Yes, we can customize your pickup and drop-off locations as per your event’s schedule. Whether it’s from your office, hotel, or specific venues, we will ensure smooth transportation for all your guests.',
    },
    {
        id: 7,
        question: 'Is 24/7 support available for bus rentals for events?',
        answer: 'Yes, we offer 24/7 support for bus rentals for events in Pune. Our team is always ready to assist you with booking, scheduling, or any last-minute changes to ensure your event transportation runs smoothly.',
    },
];

const testimonials = [
    {
        name: 'Mr. Anand Sood',
        role: 'Event Coordinator',
        text: 'We hired a 50-seater AC bus from Samarth Travels for a corporate event in Pune. The bus was well-maintained, the driver was professional, and the journey was smooth. It made transporting our team stress-free and easy. Highly recommend!',
        image: '/img/testimonial/testi_2_44.jpg',
    },
    {
        name: 'Ms. Rupal Shah',
        role: 'Wedding Planner',
        text: 'For my client’s wedding in Pune, I booked a 40-seater Non-AC bus from Samarth Travels. The service was impeccable, the bus was spacious and clean, and the guests were comfortably transported between venues. I will definitely book again for future events.',
        image: '/img/testimonial/testi_2_45.jpg',
    },
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent For Event in Pune",
  "image": "https://samarthtravels.com/assets/images/event-bus-hire.jpg",
  "description": "Rent a bus for your event travel needs in Pune, including weddings, corporate events, cultural events, conferences, and birthday parties. Affordable and luxury bus options available, including 32-seater buses for group events.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/bus-on-rent-for-event-in-pune"
  }
};





    return (
        <div>



<Helmet>
  <title>Bus on Rent For Event in Pune | Affordable & Luxury Options | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a bus for weddings, corporate events, cultural events, conferences, and birthday parties in Pune. Affordable and luxury 32-seater buses for group events and more. Comfortable travel for your special occasions." 
  />
  <meta 
    name="keywords" 
    content="Event Bus Rental Services in Pune, Rent Bus for Wedding Events in Pune, Bus Hire for Corporate Events in Pune, Bus for Cultural Events on Rent in Pune, Rent a Bus for Conferences in Pune, Bus Hire for Birthday Parties in Pune, Affordable Bus Hire for Event Travel in Pune, Bus Rental for Group Events in Pune, Luxury Bus Hire for Events in Pune, 32-Seater Bus Rental for Events in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busonrentforeventinpune;